import { render, staticRenderFns } from "./ReconciliationStep6.vue?vue&type=template&id=67770ba3&scoped=true&"
import script from "./ReconciliationStep6.vue?vue&type=script&lang=js&"
export * from "./ReconciliationStep6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67770ba3",
  null
  
)

export default component.exports